import { Autocomplete, Box, Chip, TextField, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useSupervisorSelection } from './useSupervisorSelection';

export const SupervisorsSelection = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    selectedSupervisors,
    handleRemoveSupervisor,
    supervisors,
    supervisorInputValue,
    lastTypedSupervisorValue,
    setSupervisorInputValue,
    handleAddSupervisor,
    isSupervisorsLoading,
  } = useSupervisorSelection();
  return (
    <Box id="supervisors-selection">
      <Typography variant="h6">
        {formatMessage({ id: 'adminProjects.allocation.selectSupervisors.title' })}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: theme.spacing(2), p: theme.spacing(2) }}>
        {selectedSupervisors.map((supervisor) => (
          <Chip
            key={supervisor.id}
            label={supervisor.label}
            onDelete={() => handleRemoveSupervisor(supervisor)}
            sx={{
              backgroundColor: theme.palette.grey[200],
              color: theme.palette.text.primary,
              fontSize: '13px',
              border: 0,
              cursor: 'pointer',
            }}
          />
        ))}
      </Box>
      <Autocomplete
        disabled={isSupervisorsLoading ?? false}
        options={supervisors}
        value={null}
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        inputValue={supervisorInputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            lastTypedSupervisorValue.current = newInputValue;
            setSupervisorInputValue(newInputValue);
          }
        }}
        onChange={(event, selectedOption) => {
          if (!selectedOption) return;

          handleAddSupervisor(selectedOption);

          setSupervisorInputValue(lastTypedSupervisorValue.current);
        }}
        getOptionDisabled={(option) => selectedSupervisors.some((a) => a.id === option.id)}
        renderOption={(props, option) => {
          const { key, ...otherProps } = props;

          const isSelected = selectedSupervisors.some((a) => a.id === option.id);

          return (
            <Box
              key={key}
              component="li"
              {...otherProps}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                opacity: isSelected ? 0.6 : 1,
              }}
            >
              <span>{option.label}</span>

              {isSelected && (
                <Typography
                  variant="caption"
                  color="primary"
                  sx={{ fontWeight: 600, ml: theme.spacing(2) }}
                >
                  {formatMessage({ id: 'adminProjects.autocomplete.selected' })}
                </Typography>
              )}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={formatMessage({ id: 'adminProjects.allocation.selectSupervisors.placeholder' })}
          />
        )}
      />
    </Box>
  );
};
